exports.key = 'qcbj191114'

// 设置全局变量
const varsPlugin = {
  install(Vue) {
    // 活动key
    Vue.prototype.$key = exports.key
    // 环境变量
    Vue.prototype.$env = process.env.VUE_APP_ENV
    // 不同环境的接口
    const baseURL = {}
    baseURL.cat = `https://${window.location.host}`
    if (process.env.VUE_APP_ENV === 'prod') {
      baseURL.api = 'https://api.pangku.com'
      baseURL.merchant = 'https://merchant.pangku.com'
    } else {
      baseURL.api = 'https://tapi.pangku.com'
      baseURL.merchant = 'https://prem.pangku.com'
    }
    Vue.prototype.$baseURL = baseURL
  }
}

exports.vars = varsPlugin

// 分享文案，图片上传到七牛https://pangku.com/upload/qiniu
// link填cat.pangku.com，自动判断环境
exports.shareData = {
  title: '你有一个红包待领取！',
  desc: '好友越多，红包越多呦~',
  link: 'https://cat.pangku.com/dist/qcbj191114/index.html',
  imgUrl: 'https://a-img.pangku.com/qcbj191114/1xsbvjkma9b.jpg'
}

// 重新运行才能生效
// 地址相对vue.config.js
exports.pages = {
  index: {
    template: './src/qcbj191114/base/template.html',
    title: '天天开红包',
    entry: './src/qcbj191114/index/index.js',
    filename: 'index.html',
    chunks: ['chunk-vendors', 'chunk-common', 'index']
  },
  game: {
    template: './src/qcbj191114/base/template.html',
    title: '天天开红包',
    entry: './src/qcbj191114/game/game.js',
    filename: 'game.html',
    chunks: ['chunk-vendors', 'chunk-common', 'game']
  },
  share: {
    template: './src/qcbj191114/base/template.html',
    title: '天天开红包',
    entry: './src/qcbj191114/share/share.js',
    filename: 'share.html',
    chunks: ['chunk-vendors', 'chunk-common', 'share']
  },
  jump: {
    template: './src/qcbj191114/base/template.html',
    title: '天天开红包',
    entry: './src/qcbj191114/jump/jump.js',
    filename: 'jump.html',
    chunks: ['chunk-vendors', 'chunk-common', 'jump']
  },
  rule: {
    template: './src/qcbj191114/base/template.html',
    title: '天天开红包',
    entry: './src/qcbj191114/rule/rule.js',
    filename: 'rule.html',
    chunks: ['chunk-vendors', 'chunk-common', 'rule']
  }
}

// 前端、后端和设计
exports.author = {
  frontend: '***',
  backend: '***',
  designer: '***'
}
